declare let fbq: Function;

export class AnalyticsTracker {
  constructor() { }

  userRegistering(userData: object) {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Lead', userData)
    }
  }

  userRegistered(registerData: object) {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'CompleteRegistration', registerData)
    }
  }

  viewPage(page: string) {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'PageView', page);
    }
  }

  productView(product: object) {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'ViewContent', product);
    }
  }

  addToCart(product: object) {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'AddToCart', product);
    }
  }

  startCheckout(checkoutData: object) {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'InitiateCheckout', checkoutData)
    }
  }

  purchaseCompleted(orderData: object) {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Purchase', orderData)
    }
  }





}